import { ChatDialogService } from '../services/chat-dialog.service'
import { ChatStatusDialogComponent } from './chat-status-dialog.component'
import { CHAT_STATUS_DIALOG_CONFIG } from './chat-status.util'

/**
 * Single-instance toggle for the availability picker (RF-29).
 *
 * `MatDialog.open()` is unconditional: every call stacks another overlay, so a
 * double-click — or one trigger firing while another already opened it — left two
 * identical dialogs on screen. This makes every trigger behave as a toggle:
 * activate once to open, again to close.
 *
 * The open state is read from `dialog.openDialogs` rather than from a field on
 * the caller. There are TWO triggers for this dialog (the bubble popup's
 * identity card and `chat-status-button` in the `/chat` header) and both can be
 * mounted at the same time — per-component refs would each think the dialog is
 * closed and open a second one.
 *
 * Lives in its own file so it can import the dialog component without a cycle:
 * the component imports `chat-status.util`, and nothing imports this back.
 */
export function toggleChatStatusDialog(dialog: ChatDialogService): void {
  const open = dialog.openDialogs.find(
    (ref) => ref.componentInstance instanceof ChatStatusDialogComponent,
  )

  if (open) {
    open.close()
    return
  }

  dialog.open(ChatStatusDialogComponent, CHAT_STATUS_DIALOG_CONFIG)
}
